var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-layout',[_c('v-flex',[_c('page-title')],1)],1)],1),_c('v-flex',[_c('credit-form',{attrs:{"uuid":_vm.$route.params.uuid}})],1),_c('v-flex',{attrs:{"mt-2":""}},[_c('credits-manager',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('credits',{attrs:{"credits":data}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }